"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.writeRulesOnStyleSheet = exports.getStyleSheet = void 0;
var getStyleSheet = function (elementId) {
    var stylesheetId = elementId;
    var currentStylesheet = document.getElementById(stylesheetId);
    if (currentStylesheet)
        return currentStylesheet;
    var style = document.createElement('style');
    style.id = stylesheetId;
    document.head.appendChild(style);
    return style;
};
exports.getStyleSheet = getStyleSheet;
var writeRulesOnStyleSheet = function (style, rules) {
    var _a;
    (_a = style.sheet) === null || _a === void 0 ? void 0 : _a.insertRule(rules, style.sheet.rules.length);
};
exports.writeRulesOnStyleSheet = writeRulesOnStyleSheet;
